import { useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { updateTabCache } from "../utils/pageUtils";
import { SearchKey } from "../models/SearchKey";

export function useGotoPage() {
    const navigate = useNavigate();
    const location = useLocation();

    const gotoPage = useCallback((destination: string, search?: string) => {

        const currentSearchParams = new URLSearchParams(location.search);

        // Remove the InsightId parameter
        currentSearchParams.delete(SearchKey.InsightId);

        // If additional search parameters are provided, merge them
        if (search) {
            const newSearchParams = new URLSearchParams(search);
            newSearchParams.forEach((value, key) => {
                currentSearchParams.set(key, value);
            });
        }

        navigate(destination + (currentSearchParams.toString() ? `?${currentSearchParams.toString()}` : ""));
    }, [location.search, navigate]);

    return gotoPage;
}

export function useGotoTab() {
    const gotoPage = useGotoPage();

    const gotoTab = useCallback((page: string, tab: string, tabKey: string, search?: string) => {
        gotoPage(`${page}/${tab}`, search);
        updateTabCache(tabKey, tab);
    }, [gotoPage]);

    return gotoTab;
}